module.exports = __webpack_public_path__ + "img/Ersa-VERSAFLOW-ONE-900x675.46fc5883.png";